export const productsByCategory = (products, categoryName) => {
  return products.filter(product => product.category?.name === categoryName);
};

 export const playSound = () => {
  const audio = new Audio('/sounds/retro.wav');
  audio.play().catch(e => console.log("Audio non reproduit:", e));
};
